import $http from "../../axios";
import { Notification } from "element-ui";

export async function getParamTable ({ commit, state }, id) {
    await $http.get(`/api/tablas-parametros/${id}`)
        .then((response) => {
            commit('setParamTable', response.data.data)
        })
        .catch((error) => {
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 2000,
                customClass: 'notification-box',
            });
        })
}

export async function fetchParameters ({ commit }, id) {
    await $http.get(`/api/parametros?paramtable_id=${id}`)
        .then((response) => {
            commit('setParameters', response.data.data)
        })
        .catch((error) => {
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 2000,
                customClass: 'notification-box',
            });
        })
}



// WEBPACK FOOTER //
// ./src/modules/table-parameters/actions.js